import { app } from '../../../../app';
import { groupFromDto } from '../../user-directories/group.dto';

class RoleManagementResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    list(companyId, appId) {
        const url = `app/rest/admin/company/${companyId}/application/${appId}/loginroles/all`;
        return this.$http.get(url).then(({data}) => data);
    }

    remove(companyId, appId, roleId) {
        const url = `app/rest/admin/company/${companyId}/application/${appId}/loginroles/${roleId}`;
        return this.$http.delete(url).then(({data}) => data);
    }

    save(companyId, appId, role) {
        const url = `app/rest/admin/company/${companyId}/application/${appId}/loginroles`;
        return this.$http.post(url, role).then(({data}) => data);
    }

    groups(companyId, appId) {
        const url = `app/rest/admin/company/${companyId}/application/${appId}/loginroles/groups`;
        return this.$http.get(url).then(({data}) => data)
            .then((items) => items.map((item) => ({...item, group: groupFromDto(item.group)})))
    }
}

app.service('RoleManagementResource', RoleManagementResource);



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/role-management-resource.service.js